var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.342,
    height: 53.343,
    viewBox: "0 0 53.342 53.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.333 -6.333)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5359",
    cx: 23.337,
    cy: 23.337,
    r: 23.337,
    transform: "translate(9.667 9.667)",
    style: {
      fill: "#f4f4f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45932",
    d: "M1332.674 1859.443a26 26 0 1 1-26 26 26.034 26.034 0 0 1 26-26m0-.667a26.671 26.671 0 1 0 26.671 26.671 26.7 26.7 0 0 0-26.671-26.671z",
    transform: "translate(-1299.67 -1852.443)",
    style: {
      fill: "#dfdfdf"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "youtube (4)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46276",
    d: "M22.627 2.531A2.894 2.894 0 0 0 20.59.495C18.783 0 11.551 0 11.551 0S4.32 0 2.512.476A2.954 2.954 0 0 0 .476 2.531 30.5 30.5 0 0 0 0 8.088a30.387 30.387 0 0 0 .476 5.557 2.9 2.9 0 0 0 2.036 2.036c1.827.495 9.039.495 9.039.495s7.231 0 9.039-.476a2.894 2.894 0 0 0 2.036-2.036 30.5 30.5 0 0 0 .474-5.557 28.949 28.949 0 0 0-.476-5.576zm0 0",
    transform: "translate(21.453 24.916)",
    style: {
      fill: "#151aae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46277",
    d: "m204.969 109.411 6.013-3.463-6.013-3.463zm0 0",
    transform: "translate(-174.267 -72.944)",
    style: {
      fill: "#f4f4f7"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeSocial);
export default __webpack_public_path__ + "static/media/youtube-social.90f9daebc4699889fe5798948a77fd64.svg";
export { ForwardRef as ReactComponent };